<script setup lang="ts">
import {label} from "../../mixins/translations.ts";
import {useSearchStore} from "../../stores/search.ts";

const searchStore = useSearchStore();

const toggle = () => {
    searchStore.toggleSearch = !searchStore.toggleSearch;
}
</script>

<template>
    <div class="flex">
        <button class="text-black rounded-full p-2 hover:text-primary" :class="{'text-white bg-primary hover:bg-primary/90 hover:text-white': searchStore.toggleSearch}" @click="toggle">
            <span class="sr-only">{{ label('site.search.breadcrumbs') }}</span>
            <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" width="24" height="24" v-if="!searchStore.toggleSearch"
                 viewBox="0 0 24 24"
                 fill="none" stroke-width="1.5" stroke-linecap="round" stroke="currentColor"
                 stroke-linejoin="round">
                <circle cx="11" cy="11" r="8"></circle>
                <path d="m21 21-4.3-4.3"></path>
            </svg>
            <svg v-else xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-search-x-icon lucide-search-x">
                <path d="m13.5 8.5-5 5"/><path d="m8.5 8.5 5 5"/><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/>
            </svg>
        </button>
    </div>
</template>
